import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@els/els-react--checkbox';
import { Pill } from '@els/els-react--pill';

import { replaceCitations } from '@Utils/String';

import './SelectedItemsControls.custom.scss';
import './SelectedItemsControls.theme.scss';

export default function SelectedItemsControls(props) {
  const { checkAllItems, allItemsSelected, someItemsSelected, currentSelectedItems, context } = props;

  return (
    <div className="selected-items-controls-wrapper">
      <Checkbox
        label={context ? `${currentSelectedItems} ${replaceCitations(context)} selected` : 'Select all'}
        shouldHideLabel
        onChange={() => {
          checkAllItems(!allItemsSelected);
        }}
        checked={allItemsSelected}
        indeterminate={someItemsSelected}
        // eslint-disable-next-line no-nested-ternary,sonarjs/no-nested-conditional
        aria-checked={allItemsSelected ? 'true' : someItemsSelected ? 'mixed' : 'false'}
      />
      <Pill condensed label={`${currentSelectedItems || 0}`} />
      <span className="u-els-display-none@desktop u-els-margin-left-1o2">selected</span>
    </div>
  );
}

SelectedItemsControls.propTypes = {
  checkAllItems: PropTypes.func.isRequired,
  allItemsSelected: PropTypes.bool.isRequired,
  someItemsSelected: PropTypes.bool,
  currentSelectedItems: PropTypes.number.isRequired,
};
